import { render, staticRenderFns } from "./FileUploadErrorModal.vue?vue&type=template&id=635caf8c&lang=pug"
import script from "./FileUploadErrorModal.vue?vue&type=script&lang=ts"
export * from "./FileUploadErrorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports